import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import Element from 'element-ui';
import Request from '@/assets/js/request';
import Utils from '@/assets/js/utils';
import Player from '@/assets/js/player';
import Message from '@/assets/js/resetMessage';
// import BaiduMap from 'vue-baidu-map';

import 'element-ui/lib/theme-chalk/display.css'
import '@/assets/theme/index.css'

import '@/assets/js/filter';
import cafeOfd from 'cafe-ofd'
import 'cafe-ofd/package/index.css'

Vue.config.productionTip = false;

Vue.use(Element);
Vue.use(cafeOfd);
// Vue.use(BaiduMap, {
//   ak: 'Y5qE51IMbh9Sdq2NAmMDUGGw'
// })

Vue.prototype.$request = Request;
Vue.prototype.$utils = Utils;
Vue.prototype.$player = Player;
Vue.prototype.$userType = new Map([
    [1, '乐迷'],
    [2, '艺人'],
    [3, '场地'],
    [4, '赞助商'],
    [5, '厂牌']
]);
Vue.prototype.$pageSizes = [10, 25, 50, 100];
Vue.prototype.$message = Message;

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');
